import React from 'react';
import { DownloadContainer, Message, Icon } from './DownloadingFile.style';

const DownloadingFile = () => {
	return (
		<DownloadContainer>
			<Icon viewBox="0 0 24 24">
				<path d="M12 16l4-4h-3V4h-2v8H8l4 4zm-1 4h2v-2h-2v2z" />
			</Icon>
			<Message>
				Your file download is initiated and you will be notified
			</Message>
		</DownloadContainer>
	);
};

export default DownloadingFile;
